export default __webpack_public_path__ + "static/media/turn-ideas-into-reality-2048w.d7940d42.webp";